import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const remarkPlugins = [remarkGfm];

const components = {
  p: ({ ...props }: any) => <span {...props} />,
  a: ({ ...props }: any) => (
    <a
      target="_blank"
      rel="noreferrer noopener"
      className="text-primary underline hover:text-primary/80"
      {...props}
    />
  ),
  code: ({ ...props }: any) => (
    <code className="bg-muted px-1 py-0.5 rounded text-[11px] font-mono" {...props} />
  ),
  strong: ({ ...props }: any) => <strong className="font-semibold" {...props} />,
  em: ({ ...props }: any) => <em className="italic" {...props} />,
};

export function ConfigFieldDescription({ description }: { description?: string }) {
  if (!description) return null;
  return (
    <div className="text-xs text-muted-foreground">
      <ReactMarkdown remarkPlugins={remarkPlugins} components={components}>
        {description}
      </ReactMarkdown>
    </div>
  );
}
